/** Shared chrome strings. */
export const en = {
  appName: 'Sketchling',
  continue: 'Continue',
  next: 'Next',
  back: 'Back',
  close: 'Close',
  done: 'Done',
  skip: 'Skip',
  cancel: 'Cancel',
  save: 'Save',
  yes: 'Yes',
  no: 'No',
  ok: 'OK',
  retry: 'Try again',
  maybeLater: 'Maybe later',
  loading: 'Loading…',
  delete: 'Delete',
  edit: 'Edit',
  share: 'Share',
  start: 'Start',
  ready: 'Ready',
  locked: 'Locked',
  comingSoon: 'Coming soon',
  premium: 'Premium',
  free: 'Free',
  new: 'New',
  offline: 'Whoops, no internet connection. Your drawings are saved on this device.',
  error: 'Something went wrong. Please try again.',
  'nav.learn': 'Learn',
  'nav.playground': 'Playground',
  'nav.journal': 'Journal',
  'nav.studio': 'My Studio',
  'nav.sparks': 'Sparks',
  'nav.more': 'More',
  'nav.drawTwo': 'Draw two to unlock',
  'nav.collectSparks': 'Collect {n} more sparks to unlock',
  'nav.disabled': 'Not available right now',
  sparks: 'sparks',
  level: 'Level {n}',
  levelCaps: 'LEVEL {n}',
  teacherName: 'Teacher Juno',
  mascotName: 'Scribble',
  rotateTitle: 'Turn your device sideways',
  crashTitle: 'Oops, this page tripped over its pencil!',
  crashBody: 'Your drawings are safe. Let’s try again.',
  crashRetry: 'Try again',
  crashHome: 'Go home',
  loadingScreen: 'Getting the paper ready…',
  storageFull: 'This device is almost full: new photos may not be kept. A grown-up can free some space.',
  rotateBody: 'Sketchling is made for landscape, so your paper and the lesson fit side by side.',
  'sub.animals': 'Animals',
  'sub.nature': 'Nature',
  'sub.characters': 'Characters',
  'sub.anime': 'Manga style',
  'sub.cuteObjects': 'Cute objects',
  'sub.shapes': 'Shapes',
  'sub.food': 'Food',
  'sub.vehicles': 'Vehicles',
  'sub.fantasy': 'Fantasy',
  'shelf.seeAll': 'See all',
  'shelf.seeMore': "See more",
  'shelf.thatsAll': "That's all!",
  'shelf.next': 'More to the right',
  'shelf.prev': 'Back to the left',
  'shelf.sec.lessons': 'Lessons',
  'shelf.sec.remix': 'Remix',
  'shelf.sec.pictures': 'Pictures',
  'shelf.sec.crossovers': 'Crossovers',
  'shelf.sec.doodles': 'Doodles',
  'shelf.items': '{n} to draw',
};

export const vi: Record<keyof typeof en, string> = {
  appName: 'Sketchling',
  continue: 'Tiếp tục',
  next: 'Tiếp',
  back: 'Quay lại',
  close: 'Đóng',
  done: 'Xong',
  skip: 'Bỏ qua',
  cancel: 'Huỷ',
  save: 'Lưu',
  yes: 'Có',
  no: 'Không',
  ok: 'OK',
  retry: 'Thử lại',
  maybeLater: 'Để sau',
  loading: 'Đang tải…',
  delete: 'Xoá',
  edit: 'Sửa',
  share: 'Chia sẻ',
  start: 'Bắt đầu',
  ready: 'Sẵn sàng',
  locked: 'Đang khoá',
  comingSoon: 'Sắp ra mắt',
  premium: 'Premium',
  free: 'Miễn phí',
  new: 'Mới',
  offline: 'Ối, không có mạng. Tranh của con vẫn được lưu trên máy này.',
  error: 'Có lỗi xảy ra. Vui lòng thử lại.',
  'nav.learn': 'Học vẽ',
  'nav.playground': 'Sân chơi',
  'nav.journal': 'Sổ tranh',
  'nav.studio': 'Xưởng vẽ',
  'nav.sparks': 'Tia sáng',
  'nav.more': 'Thêm',
  'nav.drawTwo': 'Vẽ hai bức để mở khoá',
  'nav.collectSparks': 'Thu thêm {n} tia sáng để mở khoá',
  'nav.disabled': 'Hiện chưa khả dụng',
  sparks: 'tia sáng',
  level: 'Cấp {n}',
  levelCaps: 'CẤP {n}',
  teacherName: 'Cô Juno',
  mascotName: 'Scribble',
  rotateTitle: 'Xoay ngang thiết bị nhé',
  crashTitle: 'Ối, trang này vấp phải cây bút chì rồi!',
  crashBody: 'Tranh của con vẫn an toàn. Mình thử lại nhé.',
  crashRetry: 'Thử lại',
  crashHome: 'Về trang chính',
  loadingScreen: 'Đang chuẩn bị giấy vẽ…',
  storageFull: 'Máy gần hết bộ nhớ: ảnh mới có thể không được lưu. Nhờ người lớn dọn bớt nhé.',
  rotateBody: 'Sketchling được thiết kế cho màn hình ngang, để tờ giấy và bài học nằm cạnh nhau.',
  'sub.animals': 'Động vật',
  'sub.nature': 'Thiên nhiên',
  'sub.characters': 'Nhân vật',
  'sub.anime': 'Truyện tranh',
  'sub.cuteObjects': 'Đồ dễ thương',
  'sub.shapes': 'Hình khối',
  'sub.food': 'Đồ ăn',
  'sub.vehicles': 'Xe cộ',
  'sub.fantasy': 'Thần tiên',
  'shelf.seeAll': 'Xem tất cả',
  'shelf.seeMore': "Xem thêm",
  'shelf.thatsAll': 'Hết rồi đó!',
  'shelf.next': 'Xem thêm bên phải',
  'shelf.prev': 'Quay lại bên trái',
  'shelf.sec.lessons': 'Bài học',
  'shelf.sec.remix': 'Biến hoá',
  'shelf.sec.pictures': 'Tranh hoàn chỉnh',
  'shelf.sec.crossovers': 'Kết hợp',
  'shelf.sec.doodles': 'Vẽ nghịch',
  'shelf.items': '{n} hình để vẽ',
};
